document.addEventListener('DOMContentLoaded', function(){
  // —— Lazy loading logic（ unchanged ） 
  if ('IntersectionObserver' in window) {
    var img = document.querySelector('.lazyload');
    if (img) {
      var io = new IntersectionObserver(function(entries, obs){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            var el = entry.target;
            el.src = el.dataset.src;
            el.classList.remove('lazyload');
            obs.unobserve(el);
          }
        });
      });
      io.observe(img);
    }
  }

  // —— Pop-ups
  function bindClose(btnId, popupEl) {
    var btn = document.getElementById(btnId);
    if (btn && popupEl) {
      btn.addEventListener('click', function(){
        popupEl.style.display = 'none';
      });
    }
  }

  // Subscription Success
  var successPopup = document.getElementById('success-popup');
  if (successPopup) {
    successPopup.style.display = 'flex';
    bindClose('close-popup', successPopup);
  }

  // Already exists
  var existsPopup = document.getElementById('exists-popup');
  if (existsPopup) {
    existsPopup.style.display = 'flex';
    bindClose('close-exists-popup', existsPopup);
  }
});
